import React, { Component } from 'react'
import './RestaurantListItem.css'

class RestaurantListItem extends Component {
  constructor(props) {
    super(props)
  }
  render() {
    const { restaurant } = this.props
    const street = restaurant.address.split(',')[0]
    return (
      <div className="restaurant">
        <a className="name" href={`/${restaurant.id}`}>{this.props.restaurant.name}</a>
        <address>{street}</address>
      </div>
    )
  }
}

export default RestaurantListItem



// WEBPACK FOOTER //
// ./src/components/RestaurantListItem.js